<template>
  <div id="category-grid">
    <router-link
      v-for="el in offerData"
      :key="el.id"
      class="thumbnail"
      :style="{ backgroundImage: 'url('+ el.image +')' }"
      :to="`/oferta/${getCategoryUrl(el.title)}/`"
      v-html="el.title.toUpperCase()"
    ></router-link>
  </div>
</template>

<script>
export default {
  name: 'CategoryGrid',
  props: {
    offerData: Array,
  },
  filters: {
    uppercase: value => value.toUpperCase(),
  },
  methods: {
    getCategoryUrl(value) {
      return value.split(' ').join('_').toLowerCase();
    },

    fixSize() {
      if (window.innerWidth >= 992) {
        const list = document.querySelectorAll('.thumbnail');

        for (let i = 0; i < list.length; i++) {
          const w = list[i].innerHTML.length;
          if (w > 20) list[i].style.fontSize = '1.3em';
          else if (w > 30) list[i].style.fontSize = '1.2em';
          else if (w > 40) list[i].style.fontSize = '1em';
        }
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.fixSize);
    setTimeout(this.fixSize, 1);
  },
};
</script>

<style scoped lang="scss">
  #category-grid {
    display: grid;
    grid-gap: 15px;
    position: relative;

    padding: 15px;

    @media (min-width: 768px) {
      grid-template-columns: 50% 50%;
      padding: 15px 25px;
    }

    @media (min-width: 992px) {
      grid-template-columns: 33% 33% 33%;
      grid-gap: 10px;
      padding: 25px 100px;
    }

    @media (min-width: 1200px) {
      $width: 1200px;

      width: $width;
      left: calc(50% - calc(#{$width} / 2));
      padding: 50px 25px;
    }
  }

  .thumbnail {
    background-position: center;
    background-size: cover;
    background-color: rgba(0,0,0, 0.7);
    background-blend-mode: color;
    height: 160px;

    position: relative;
    display: flex;
    justify-content: center; align-items: center;
    padding: 10px;

    color: white;

    font-family: 'Josefin Sans', sans-serif;
    font-weight: bold;
    line-height: 28px;
    font-size: 1.6em;
    text-wrap: normal;

    @media (min-width: 768px) {
      flex-basis: 50%;
      height: 100%; width: 100%;

      &::before {
        content: ''; display: block;
        padding-top: 100%;
      }

      font-size: 1.8em;
      line-height: 34px;
    }
  }
</style>
